import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import useSeo from '@/hooks/useSeo';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import PopularSection from './components/PopularSection';
import UpdateSection from './components/UpdateSection';
import FaqSection from './components/FaqSection';
import CtaBand from './components/CtaBand';

export default function Home() {
  useSeo({
    title: '漫画韩漫网址 - 恋爱/都市/奇幻/校园/悬疑/热血题材分类站',
    description:
      '漫画韩漫网址内容分类站，按漫画韩漫网址恋爱、都市、奇幻、校园等题材整理，悬疑与热血分类齐全，快速定位想看的韩漫。',
  });

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'Organization',
                name: '漫画韩漫网址',
                url: 'https://suspensek.github.io/',
                logo: 'https://suspensek.github.io/vite.svg',
                description: '专注于整理和分类优质韩漫题材的内容导航站。',
              },
              {
                '@type': 'WebSite',
                name: '漫画韩漫网址',
                url: 'https://suspensek.github.io/',
                description: '按恋爱、都市、奇幻、校园、悬疑、热血等题材分类整理的韩漫导航站。',
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <PopularSection />
        <UpdateSection />
        <FaqSection />
        <CtaBand />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}